/* eslint-disable prefer-destructuring, react/jsx-no-constructed-context-values, react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { genUUID } from 'src/helpers';

export const LanguageContext = createContext({
  translations: {},
  in18n: {},
});

export const useLanguageContext = () => useContext(LanguageContext);

export function LanguageContextProvider({ children }) {
  const [localStorageLocale, setLocalStorageLocale] = useLocalStorage(
    'showcase-locale',
  );

  const [translations] = useState({});

  const [i18n, setI18n] = useState(() => {
    if (localStorageLocale) {
      return localStorageLocale;
    }
    return {};
  });

  const [languages] = useState([]);
  const [defaultLanguage, setDefaultLanguages] = useState({});

  const getDataLanguages = async () => {
    setDefaultLanguages({
      locale: 'en',
      id: genUUID('en', 'Language'),
      code: 'en',
      name: 'English',
    });
  };

  const getDataI18n = async () => {};

  useEffect(() => {
    getDataLanguages();
  }, []);

  useEffect(() => {
    if (defaultLanguage.locale) {
      setI18n(defaultLanguage);
    }
  }, [defaultLanguage]);

  useEffect(() => {
    if (i18n?.locale) {
      getDataI18n(i18n?.locale);
    }
  }, [i18n?.locale]);

  return (
    <LanguageContext.Provider
      value={{ languages, i18n, setI18n, translations, setLocalStorageLocale }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

LanguageContextProvider.propTypes = {
  children: PropTypes.node,
};
